const countryPicker = document.querySelector('.js-country-picker');
const trigger = document.querySelector('.js-country-picker__trigger');
const selectMenu = document.getElementById('countryPickerContent');

/**
 * Initializes the country selection module.
 */
export function initCountryPicker() {
  if (!countryPicker) {
    return false;
  }
  handleCountryPickerMenu();
  return false;
}

/**
 * Adds event listeners to country select trigger and the document body
 */
function handleCountryPickerMenu() {
  trigger.addEventListener('click', () => {
    const countryPickerIsOpen = countryPicker.classList.contains('is-active');
    if (countryPickerIsOpen) {
      closeCountryPicker();
    } else {
      openCountryPicker();
    }
  });

  trigger.addEventListener('mouseenter', () => {
    openCountryPicker();
  });

  document.addEventListener('keydown', handleKeyPress);
  document.addEventListener('mousedown', handleMouseDown);
}

/**
 * Opens the country select menu
 * @param {Node} dropdownMenu The menu to open.
 */
function openCountryPicker() {
  selectMenu.style.display = 'block';
  trigger.setAttribute('aria-expanded', 'true');

  // Wait for display to change
  setTimeout(() => {
    countryPicker.classList.add('is-active');
    document.addEventListener('keydown', handleKeyPress);
  }, 30);
}

/**
 * Closes a dropdown menu
 * @param {Node} dropdownMenu The menu to close
 */
function closeCountryPicker() {
  trigger.setAttribute('aria-expanded', 'false');
  selectMenu.style.display = 'none';
  countryPicker.classList.remove('is-active');
  document.removeEventListener('keydown', handleKeyPress);
}

/**
 * Listens for esc and closes the nav
 */
function handleKeyPress(event) {
  if (event.keyCode === 27) {
    closeCountryPicker();
  }
}

/**
 * Closes nav items on mousedown
 * @param {Object} event The mouse down event
 */
function handleMouseDown(event) {
  if (
    countryPicker !== event.target &&
    !countryPicker.contains(event.target) &&
    !document.querySelectorAll('.js-modal.is-active').length
  ) {
    closeCountryPicker();
  }
}
